import { AbstractScatterVisualization } from './../visualization.abstract.scatter.component';
export class PcaSparseGraph extends AbstractScatterVisualization {
}
